<template>
  <div
    class="nav-sidebar flex flex-col flex-shrink-0 justify-between border-r border-white-800 h-full py-24 duration-200"
    :class="[isSidebarOpened ? 'w-[260px] px-30' : 'w-[86px]']"
  >
    <div class="mb-[55px]">
      <!-- Logo -->
      <div class="flex items-center justify-center" :class="{'px-12': !isSidebarOpened}">
        <LogoBigDefault v-show="isSidebarOpened" class="w-[168px] h-[68px] mb-8" />

        <LogoSmallDefault v-show="!isSidebarOpened" class="mb-12 max-w-[61px]" />
      </div>

      <!-- Collapse button  -->
      <div class="w-full flex justify-center">
        <AppButton
          variant="outlined"
          class="square-sm"
          @click="toggleSidebar"
        >
          <PhCaretLeft
            size="18"
            weight="bold"
            class="transition-transform"
            :class="{'rotate-180': !isSidebarOpened}"
          />
        </AppButton>
      </div>
    </div>

    <div class="flex flex-col flex-1 justify-between h-hull">
      <!-- Menu list -->
      <div
        :class="!isSidebarOpened ? 'flex flex-col justify-center items-center' : ''"
        data-testid="sidebar-navigation-list"
      >
        <template v-for="item in navigationList" :key="item.name">
          <router-link
            class="max-w-[100%] flex items-center gap-12 font-medium px-12 py-8 mb-20 hover:text-black-900
             transition cursor-pointer"
            :class="[
              [route.name, route.meta.parentName].includes(item.name) ?
                'text-black-900 rounded-md bg-blue-4-400' : 'text-black-600',
              {'justify-center': !isSidebarOpened}
            ]"
            :data-testid="item.meta?.routeTestId"
            :to="{ name: item.name }"
          >
            <AppTooltip :content="item.meta?.label" :disabled="isSidebarOpened">
              <component :is="item.meta?.icon" size="24" weight="bold" class="shrink-0 outline-none" />
            </AppTooltip>

            <span v-if="isSidebarOpened" class="shrink-0">{{ item.meta?.label }}</span>
          </router-link>
        </template>
      </div>

      <!-- Log out -->
      <button
        class="w-full flex justify-start text-black-600 gap-12 items-center cursor-pointer hover:text-black-900"
        :class="{'justify-center': !isSidebarOpened}"
        @click="logout"
      >
        <PhSignOut size="20" weight="bold" class="shrink-0" />

        <p v-if="isSidebarOpened" class="min-w-[58px] font-medium">Log out</p>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const isSidebarOpened = useLocalStorage('isSidebarOpened', true)

const router = useRouter()
const route = useRoute()

const authStore = useAuthStore()

const navigationList = computed(() => {
  const route = authService.getDefaultRoleRoute()
  const navRoutes = router.options.routes.find((item) => item.name === route.name)

  return (navRoutes?.children)?.filter((route) => !route.meta?.notRenderInSidebar)
})

function toggleSidebar () {
  isSidebarOpened.value = !isSidebarOpened.value
}

function logout () {
  authStore.handleSignOut()
}
</script>
